
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/terms/terms-and-conditions",
      function () {
        return require("private-next-pages/terms/terms-and-conditions/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/terms/terms-and-conditions"])
      });
    }
  